(async() => {
    const { Core } = await importModule('Core');

    customElements.define('main-navigation-mobile', class extends Core {
        elements = {
            stage: '[data-stage]',
            navItems: '*[data-to-lvl]',
            innerWrapper:"[navigation-drawer-inner]"
        }

        render() {
            this._handleNavigation();
        }
        
        _handleNavigation() {
            this.$navItems.map(item => {
                item.addEventListener('click', e => {
                    this.$stage.dataset.current = item.dataset.toLvl;                  
                     document.querySelector(this.elements.innerWrapper).scrollTo(0,0);
                })
            })
        }
    });

})()